<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header small-header">
        <h1>Survey Complete</h1>
      </div>
      <div class="page-form-content">
        <div class="form-description">
          Thank you! We have recorded your answers <br /> 
          for your <span class="text-success">{{ surveyTypeName }}</span>.
        </div>
        <b-form-group>
          <h5 class="form-heading">Now what?</h5>
          <ul class="form-listing">
            <li v-if="isCurative && survey.labworkType === labworkType.ByClient">
              If they haven't already done so, your Curative Care Coordinator or the
              healthcare provider that ordered your risk assessment will coordinate with
              you to collect the bloodwork necessary to evaluate your biomarkers.
            </li>
            <li v-else>
              If they have not already done so, the clinic that ordered your Assessment will contact you to 
              schedule your fasted blood draw that will let us complete your assessment. You will be asked to 
              fast for 10-12 hours prior to your draw and it should only take a few minutes of your time to complete. 
              Then your bloodwork will be analyzed by the highly sensitive nuclear magnetic resonance (NMR) technology at the main 
              LabCorp lab in Burlington, NC.
            </li>
            <li>
              After we receive your results from Labcorp, we will produce your <span class="text-success">{{ surveyTypeName }}</span> that
              both you and your care provider at <span class="text-success">{{ survey.clientName }}</span> will receive a copy of. You will be able to access
              all of your completed report under <router-link to="reports">My Reports</router-link>.
            </li>
          </ul>
        </b-form-group>
        <b-form-group class="form-buttons">
          <b-btn variant="light" to="/">Home</b-btn>
          <b-btn variant="success" to="/reports">My Reports</b-btn>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  import productType from 'enums/product-type';
  import labworkType from 'enums/labwork-type';
  import { curativeClient } from "@/constants";

  export default {
    data() {
      return {
        labworkType
      }
    },

    computed: {
      ...mapState("survey", ["survey"]),

      surveyTypeName() {
        switch (this.survey.type) {
          case productType.InitialCRAAPOB:
            return "Cardiometabolic Risk Assessment";
          case productType.InitialCRALDLP:
            return "Cardiometabolic Risk Assessment";
          case productType.RepeatedCRALDLP:
            return "Follow-up Cardiometabolic Risk Assessment";
          case productType.RepeatedCRAAPOB:
            return "Follow-up Cardiometabolic Risk Assessment";
          case productType.AdvancedCRAAPOB:
            return "Advanced Cardiometabolic Risk Assessment";
          case productType.RepeatedAdvancedCRAAPOB:
            return "Follow-up Advanced Cardiometabolic Risk Assessment";
          default:
            return "Diabetic Risk Assessment"
        }
      },

      isCurative() {
        return this.$auth.isFeatureAvailable(curativeClient);
      }
    },

    methods: {
      ...mapActions("user", ["getCurrentUser"])
    },

    async created() {
      await this.getCurrentUser();
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/styles/mixins';

  .page {
    @include retina('/png/table-coffee.png');
  }
</style>